export enum AccessTicketPeriodOptions {
  NONE = 'NONE',
  ONCE_A_DAY = 'ONCE_A_DAY',
  ONCE_A_WEEK = 'ONCE_A_WEEK',
  ONCE_A_MONTH = 'ONCE_A_MONTH',
  AFTER_DELAY = 'AFTER_DELAY',
  IMMEDIATELY = 'IMMEDIATELY',
}
